import styled, { css, keyframes } from 'styled-components';
import buttons from '../../assets/images/tablet_buttons.svg';
import tabletStroke from '../../assets/images/tablet_stroke.svg';

const shakeAnimation = keyframes`
  0% { transform: none; }
  10% { transform: translate(-2px, -2px) scale(0.98) rotate(-1deg); }
  20% { transform: translate(2px, 2px) scale(1.02) rotate(1deg); }
  30% { transform: translate(-3px, -3px) scale(0.99) rotate(-2deg); }
  40% { transform: translate(3px, 3px) scale(1.01) rotate(2deg); }
  50% { transform: translate(-2px, 2px) scale(0.98) rotate(-1deg); }
  60% { transform: translate(2px, -2px) scale(1.02) rotate(1deg); }
  70% { transform: translate(-1px, 1px) scale(0.99) rotate(-1deg); }
  80% { transform: translate(1px, -1px) scale(1.01) rotate(1deg); }
  90% { transform: translate(-1px, -1px) scale(0.99) rotate(-0.5deg); }
  100% { transform: none; }
`;

const shakeStyles = css`
	animation: ${shakeAnimation} 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
	transform: translate3d(0, 0, 0);
	backface-visibility: hidden;
	perspective: 1000px;
`;

const StyledContainer = styled.div<{ $isShaking?: boolean }>`
	position: absolute;
	top: calc(50% - 360px);
	left: calc(50% - 532px);
	transform: translateY(200%);
	width: 1064px;
	height: 720px;
	background-color: #000000;
	background-image: url(${tabletStroke});
	border-radius: 50px;
	transition: transform 0.3s ease 0.1s;
	${(props) => props.$isShaking && shakeStyles}
`;

const StyledButtons = styled.div`
	position: absolute;
	top: -3px;
	left: -3px;
	z-index: -1;
	pointer-events: none;
	width: 157px;
	height: 93px;
	background-image: url(${buttons});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledScreenContainer = styled.div`
	position: absolute;
	top: 20px;
	left: 20px;
	width: 1020px;
	height: 680px;
	border-radius: 30px;
	background-color: #000000;
	overflow: hidden;
`;

const StyledTabletTopContainer = styled.div`
	position: absolute;
	top: 18px;
	left: 0;
	width: 100%;
	padding: 0 20px;
	z-index: 2;
`;

export {
	StyledButtons,
	StyledContainer,
	StyledScreenContainer,
	StyledTabletTopContainer,
};
